module.exports = __webpack_public_path__ + "media/images/konintodoke/printout/1-1-8e3a261e077f1de6690625e8ee3fd33d.png";